import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";

export const qrApi = createApi({
  reducerPath: "qrApi",
  baseQuery: appBaseQuery,
  tagTypes: ["QRVerification"],
  endpoints: (builder) => ({
    verifyQr: builder.mutation({
      query: (payload) => ({
        url: "qr/verify",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useVerifyQrMutation } = qrApi;
